import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=1dd879ab&scoped=true"
import script from "./registerForm.vue?vue&type=script&lang=js"
export * from "./registerForm.vue?vue&type=script&lang=js"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=1dd879ab&prod&lang=less&scoped=true"
import style1 from "./registerForm.vue?vue&type=style&index=1&id=1dd879ab&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd879ab",
  null
  
)

export default component.exports